export const FETCH_SEND_EMAIL_SHOPPING_LIST_REQUEST = 'FETCH_SEND_EMAIL_SHOPPING_LIST_REQUEST'
export const FETCH_SEND_EMAIL_SHOPPING_LIST_SUCCESS = 'FETCH_SEND_EMAIL_SHOPPING_LIST_SUCCESS'
export const FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR = 'FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR'

export const SET_EMAIL_ADDRESS = 'SET_EMAIL_ADDRESS'
